<template>
        <div class="caretBox" @click="changeCaret">
                <span>
                        <slot></slot>
                </span>
                <div class="caretBtn">
                        <span class="el-icon-caret-top" :style="'margin-bottom:-4px;font-size:'+size+'px;color:'+colorTop+';'"></span>
                        <span class="el-icon-caret-bottom" :style="'margin-top:-4px;font-size:'+size+'px;color:'+colorBottom+';'"></span>
                </div>

        </div>
</template>
<style scoped>
.caretBox{
        display: flex;
        justify-content: left;
        align-items: center;

}
.caretBtn{
        margin-left: 5px;
        display: flex;
        justify-content: center;
        flex-direction: column;
}
</style>
<script>
export default {
        props:{
                size:{
                        default:16
                }
        },
        data(){
                return{
                        orderType:null,


                }
        },
        computed:{
                colorBottom(){
                        let color = '#909399';
                        if(this.orderType == 'descending'){
                                color = '#409EFF'
                        }else{
                                color = '#909399'
                        }
                        return color;
                },
                colorTop(){
                        let color = '#909399';
                        if(this.orderType == 'ascending'){
                                color = '#409EFF'
                        }else{
                                color = '#909399'
                        }
                        return color;
                },
        },
        methods:{
                changeCaret(){
                        if(this.orderType == 'descending'){
                                this.orderType = null;
                        }else if(this.orderType == 'ascending'){
                                this.orderType = 'descending';
                        }else if(!this.orderType){
                                this.orderType = 'ascending';
                        }
                        this.$emit('sort-change',{order:this.orderType})
                }
        }
}
</script>